import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Text' },
    { value: 2, label: 'Textarea' },
    { value: 3, label: 'Radio' },
    { value: 4, label: 'Checkbox' },
    { value: 5, label: 'Date' },
    { value: 6, label: 'Email' },
    { value: 7, label: 'Number' },
    { value: 8, label: 'URL' },
    { value: 9, label: 'Select' },
    { value: 10, label: 'Multi Select' },
    { value: 11, label: 'Switch' },
    { value: 12, label: 'Color' },
    { value: 13, label: 'Editable List' },
    { value: 14, label: 'Jurisdictional ID' },
    { value: 15, label: 'File' },
    { value: 16, label: 'Title' },
    { value: 17, label: 'Description' },
    { value: 18, label: 'Sortable List' },
    { value: 19, label: 'WYSIWYG Editor' },
  ],
});
